export default __webpack_public_path__ + "static/media/client2.7ba2318e.png";